/* ==========================================================================
   OchreLane — mobile "Select a size" sheet for the sticky add-to-cart
   Added 25 Aug 2026.

   Venroy-style flow on phones (<=749px): the bottom sticky bar shows a single
   full-width "Select a size" button; tapping it opens a bottom sheet with an
   optional model-fit note, a Runs small - True to size - Runs large meter, a
   "View size guide" link, and a tappable list of sizes (sold-out sizes are
   disabled). Tapping an available size adds it to cart straight away
   (quick-add) by driving the theme's own sticky product form.

   Reuses the theme's existing sticky_cart form + its embedded variants JSON, so
   it works for any option setup (incl. the DD+ size list). It never rewrites
   sections/main-product.liquid.

   Scope / safety:
   - Mobile only. On desktop the injected trigger stays display:none (see
     Section 4 of ochrelane-custom.css) and the bar behaves exactly as before.
   - The native price + buttons are only hidden once this script has added the
     `ol-sheet-enabled` class, so if the script fails the theme's normal
     price + Add-to-cart bar still shows (graceful fallback).
   - B2B: the whole bar is display:none for SparkLayer customers, so the
     trigger inside it is hidden too — no change for B2B.

   Loaded from snippets/js-utilities.liquid (product pages only), which also
   prints an #ol-size-sheet-data JSON block (fit scale, model note, size-guide
   URL). Revert: remove that include + JSON block, delete this file, and delete
   Section 4 of ochrelane-custom.css.

   3 Nov 2026: the meter is gone (the fit note stays). The row under the title
   has the fit quiz link (when snippets/ol-fit-finder.liquid is on the page) and
   "View size guide", which opens the MP Size Chart app's chart for the product.
   Sizes written "6AU / US2" show one system: US for US and Canada shoppers, AU
   for everyone else (sizeSystem in the data). The sheet is half the screen high
   and scrolls; the DD+ test products set their own title.
   Later on 3 Nov: a quarter of the screen high, titled "Select your size", and
   with no quiz on the page the size guide link sits beside the title.
   Any [data-ol-size-guide] link on the page (the size picker's "Size Guide" too)
   opens the app's chart, or the size guide page if the app isn't there.
   ========================================================================== */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';

  function cfgData() {
    var el = document.getElementById('ol-size-sheet-data');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  // "6AU / US2" -> "6AU", or "US2" for US and Canada shoppers. Other sizes as they are.
  function sizeLabel(value) {
    var parts = String(value).split(' / ');
    if (parts.length !== 2 || !/AU$/.test(parts[0]) || !/^US/.test(parts[1])) return value;
    return cfgData().sizeSystem === 'US' ? parts[1] : parts[0];
  }

  function variantsJson(bar) {
    var s = bar.querySelector('.sticky-cart__form variant-selects script[type="application/json"]');
    if (!s) return [];
    try { return JSON.parse(s.textContent) || []; } catch (e) { return []; }
  }

  function buildSheet() {
    var d = cfgData();
    var overlay = document.createElement('div');
    overlay.className = 'ol-size-sheet';
    overlay.setAttribute('hidden', '');

    // The fit quiz (snippets/ol-fit-finder.liquid) opens from any [data-ol-ff-open] button.
    var quizHtml = document.querySelector('[data-ol-ff-modal]') ? '<button type="button" class="ol-size-sheet__quiz" data-ol-ff-open>Take the fit quiz</button>' : '';
    var guideHtml = d.sizeGuideUrl ? '<a class="ol-size-sheet__guide" href="' + encodeURI(d.sizeGuideUrl) + '" data-ol-size-guide>View size guide</a>' : '';
    var noteHtml = d.fitNote ? '<div class="ol-size-sheet__note">' + escapeHtml(d.fitNote) + '</div>' : '';

    // Without the quiz, the size guide link moves up beside the title to save a row.
    overlay.innerHTML =
      '<div class="ol-size-sheet__backdrop" data-close></div>' +
      '<div class="ol-size-sheet__panel" role="dialog" aria-modal="true" aria-label="Select your size">' +
        '<div class="ol-size-sheet__head">' +
          '<span class="ol-size-sheet__title">Select your size</span>' +
          (quizHtml ? '' : guideHtml) +
          '<button type="button" class="ol-size-sheet__close" aria-label="Close" data-close>&times;</button>' +
        '</div>' +
        (quizHtml ? '<div class="ol-size-sheet__links">' + quizHtml + guideHtml + '</div>' : '') +
        noteHtml +
        '<div class="ol-size-sheet__groups"></div>' +
      '</div>';

    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) {
      if (!e.target) return;
      // The quiz opens over the page once the sheet is out of the way.
      if (e.target.hasAttribute('data-close') || e.target.closest('[data-ol-ff-open]')) closeSheet(overlay);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeSheet(overlay);
    });
    return overlay;
  }

  function matchVariantId(bar, values) {
    var variants = variantsJson(bar);
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      if (opts.length === values.length && opts.every(function (o, idx) { return String(o) === String(values[idx]); })) {
        return variants[i].id;
      }
    }
    return null;
  }

  function setTitle(overlay, text) {
    overlay.querySelector('.ol-size-sheet__title').textContent = text;
    overlay.querySelector('.ol-size-sheet__panel').setAttribute('aria-label', text);
  }

  function renderGroups(overlay, bar, form) {
    var groups = overlay.querySelector('.ol-size-sheet__groups');
    groups.innerHTML = '';
    // DD+ cup/size test products list their own choices and title (assets/ol-cup-picker.js).
    var cupTitle = window.OLCupPicker && window.OLCupPicker.renderSheet(groups, function (id) { addVariant(overlay, form, id); });
    setTitle(overlay, typeof cupTitle === 'string' ? cupTitle : 'Select your size');
    if (cupTitle) return;
    var selects = Array.prototype.slice.call(form.querySelectorAll('select'));
    var multi = selects.length > 1;
    var touched = new Set();

    selects.forEach(function (sel) {
      var group = document.createElement('div');
      group.className = 'ol-size-sheet__group';
      if (multi) {
        var wrap = sel.closest('.product-form__input');
        var label = wrap && wrap.getAttribute('data-option-slug');
        if (label) group.innerHTML = '<p class="ol-size-sheet__group-label">' + escapeHtml(label) + '</p>';
      }
      Array.prototype.slice.call(sel.options).forEach(function (opt) {
        var soldOut = opt.disabled || opt.hasAttribute('data-crossout');
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'ol-size-row' + (soldOut ? ' is-soldout' : '') + (opt.selected ? ' is-selected' : '');
        row.textContent = sizeLabel(opt.value);
        if (soldOut) {
          row.disabled = true;
        } else {
          row.addEventListener('click', function () {
            sel.value = opt.value; // set selection WITHOUT dispatching change (no section re-render)
            touched.add(sel);
            Array.prototype.slice.call(group.querySelectorAll('.ol-size-row')).forEach(function (x) { x.classList.remove('is-selected'); });
            row.classList.add('is-selected');
            // Quick-add once every option group has been chosen (single-option = one tap).
            if (touched.size >= selects.length) quickAdd(overlay, bar, form, selects);
          });
        }
        group.appendChild(row);
      });
      groups.appendChild(group);
    });
  }

  // Quick-add by delegating to the theme's OWN sticky add-to-cart: set the
  // resolved variant id on the sticky form, then click its native add button.
  // Whatever the store normally does on an add then happens identically here
  // (this store's third-party cart drawer opens and stays on the PDP; a store
  // without a drawer would follow the theme's own post-add behaviour). We set
  // the id directly and do NOT dispatch a variant `change`, so nothing
  // re-renders mid-add.
  function quickAdd(overlay, bar, form, selects) {
    var values = selects.map(function (s) { return s.value; });
    addVariant(overlay, form, matchVariantId(bar, values));
  }

  function addVariant(overlay, form, id) {
    var idInput = form.querySelector('input[name="id"]');
    if (id && idInput) { idInput.value = id; idInput.disabled = false; }
    var btn = form.querySelector('button[name="add"], button[type="submit"]');
    closeSheet(overlay);
    if (!btn) return;
    // Tells ol-cup-picker.js this add already has a size (until one is chosen on the
    // page, it otherwise sends the bar's Add to cart back to the picker).
    form.dataset.olQuickAdd = '1';
    btn.click();
    delete form.dataset.olQuickAdd;
  }

  function openSheet(overlay, bar, form) {
    renderGroups(overlay, bar, form);
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('ol-size-sheet-open');
  }
  function closeSheet(overlay) {
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('ol-size-sheet-open');
  }

  function initBar(wrapper) {
    var bar = wrapper.querySelector('.product-sticky-cart');
    if (!bar) return;
    var sticky = bar.querySelector('.sticky-cart');
    var form = bar.querySelector('.sticky-cart__form form');
    if (!sticky || !form) return;
    // No size/variant options (single-variant product) -> leave the normal
    // price + Add-to-cart bar; a "Select a size" sheet would make no sense.
    if (form.querySelectorAll('select').length === 0) return;

    var overlay = document.querySelector('.ol-size-sheet') || buildSheet();

    function ensureTrigger() {
      if (sticky.querySelector('.ol-size-trigger')) return;
      var trg = document.createElement('button');
      trg.type = 'button';
      // Reuse the theme's primary button classes so the trigger matches the
      // normal buy button's colour/shape exactly.
      trg.className = 'ol-size-trigger button button--full-width';
      trg.textContent = 'Select your size';
      trg.addEventListener('click', function () { openSheet(overlay, bar, form); });
      sticky.appendChild(trg);
    }
    ensureTrigger();

    if (wrapper.dataset.olSheetInit) return; // observer/flag only once
    wrapper.dataset.olSheetInit = '1';
    wrapper.classList.add('ol-sheet-enabled');

    // Re-add the trigger if the theme re-renders the sticky bar on variant change.
    new MutationObserver(function () { ensureTrigger(); })
      .observe(sticky, { childList: true, subtree: true });
  }

  // Hide the always-on sticky bar whenever the main product-form Add to cart is
  // on screen, so the two never show at once; reveal it again once the main
  // button scrolls out of view. Toggles `ol-atc-visible` on the <animate-sticky>
  // wrapper; the CSS (Section 3b) does the slide. Mobile only.
  function initHideOnAtc(wrapper) {
    if (wrapper.dataset.olAtcWatch || !('IntersectionObserver' in window)) return;
    var info = document.querySelector('.product__info-container');
    var atc = info && (info.querySelector('.product-form__submit') || info.querySelector('button[name="add"]'));
    if (!atc) return;
    wrapper.dataset.olAtcWatch = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        wrapper.classList.toggle('ol-atc-visible', e.isIntersecting);
      });
    }, { threshold: 0 }).observe(atc);
  }

  function init() {
    if (!window.matchMedia || !window.matchMedia(MOBILE).matches) return; // mobile only
    var wrapper = document.querySelector('animate-sticky.sticky-cart-wrapper');
    if (!wrapper) return;
    initHideOnAtc(wrapper);
    initBar(wrapper);
  }

  // Size guide links open the MP Size Chart app's chart for this product (its own
  // button stays on the page, hidden where the picker has the link); without the
  // app they go to the size guide page. On every screen size.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('[data-ol-size-guide]');
    if (!link) return;
    var appButton = document.querySelector('.Avada-inline-button');
    if (!appButton) return;
    e.preventDefault();
    var sheet = document.querySelector('.ol-size-sheet');
    if (sheet && !sheet.hasAttribute('hidden')) closeSheet(sheet);
    appButton.click();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Also init if the viewport crosses into mobile after load.
  if (window.matchMedia) {
    var mq = window.matchMedia(MOBILE);
    var onChange = function (e) { if (e.matches) init(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();
